import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//引入element-plus
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

// 引入自己的公共样式
import "@/assets/css/global.scss";

//引入axios
import axios from "axios";

//使用axios
window.axios = axios;
import { install } from "@icon-park/vue-next/es/all";
import "@icon-park/vue-next/styles/index.css";

const app = createApp(App);

import { completeDirective } from "@/utils/directive.js";

app.directive("complete", completeDirective);

install(app);

// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

import glEmpty from "@/components/glEmpty/index.vue";
app.component("glEmpty", glEmpty);

app.use(store).use(router).use(ElementPlus, { locale: zhCn }).mount("#app");
